import fetchProductCatNavFilters from "@faire/web-api--source/api/v2/search/products/cat-nav/filters/post";
import { getQueryKey as getQueryKeyProductCatNavFilters } from "@faire/web-api--source/api/v2/search/products/cat-nav/filters/post-hooks";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useLoggedOutCategoryPageCatNavFilterRequest } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/__internal__/useLoggedOutCategoryPageCatNavFilterRequest";

export const useLoggedOutCategoryPageFilterSections = () => {
  const request = useLoggedOutCategoryPageCatNavFilterRequest();

  const { data, isFetching } = useQuery({
    queryKey: getQueryKeyProductCatNavFilters(request),
    queryFn: () => fetchProductCatNavFilters(request),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
  return {
    data: {
      filterSections: data?.filter_sections ?? [],
    },
    isFetching,
  };
};
